export const TITLE_CONTAINER = '8vh';
// export const TRANSLATE = { default: "80vh", hover: "40vh" };
export const TRANSLATE = '80vh';
export const TRANSLATE_HOVER = '40vh';

export const CARD_WIDTH = '500px';
export const CARD_WIDTH_SM = 'calc(100% - 60px)';

export const CARD_HEIGHT = '100px';

export const RULES = {
  c_c: 0,
  c_b: -1,
  b_c: 1,
  b_b: -4,
}

export const NUMBER_OF_ITEMS = 300;

const PUBLIC_ASSET_URL =
  process.env.REACT_APP_R2_PUBLIC_URL;

export const getPublicAssetUrl = (filename) =>
  `${PUBLIC_ASSET_URL.replace(/\/$/, '')}/${filename}`;

export const PICS_OPTIONS = [
  getPublicAssetUrl('1.jpg'),
  getPublicAssetUrl('2.jpg'),
  getPublicAssetUrl('3.jpg'),
  getPublicAssetUrl('4.jpg'),
  getPublicAssetUrl('5.jpg'),
  getPublicAssetUrl('6.jpg'),
  getPublicAssetUrl('7.jpg'),
  getPublicAssetUrl('8.jpg'), // equilibrium
  getPublicAssetUrl('9.jpg'),
  getPublicAssetUrl('10.jpg'),
  getPublicAssetUrl('11.jpg'),
  getPublicAssetUrl('12.jpg'),
  getPublicAssetUrl('13.jpg'),
  getPublicAssetUrl('14.jpg'),
  getPublicAssetUrl('15.jpg'),
];

export const PICS_OPTION_KEY = {
  cooperate: getPublicAssetUrl('cooperate.jpg'),
  betray: getPublicAssetUrl('betray.jpg'),
  none: 'https://imgur.com/aWS9TAH.png',
};
